import React, { useRef } from "react";
import HeroSection from "../components/HeroSection";
import { Testimonials } from "../../LandingPage/Testimonials";
import SaddleSelectionControls from "../components/SaddleSelectionControls";
import BillyCookBrandSection from "./BillyCookBrandSection";

const BillyCook = () => {
  const saddleSectionRef = useRef(null);

  return (
    <>
      <HeroSection scrollRef={saddleSectionRef} />
      <BillyCookBrandSection />
      <SaddleSelectionControls ref={saddleSectionRef} isBillyCook />
      <Testimonials />
    </>
  );
};

export default BillyCook;
